/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState, useEffect, useRef } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp, getConfig } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'
import FacebookLogin from '@greatsumini/react-facebook-login';
import { Schema } from 'inspector'
import { combineSelect2Values, normalizeLinkedinUsername, Select2Option } from '../../helpers/utility'
import DatePicker, { registerLocale } from "react-datepicker";
import "../../../styles/react-datepicker.css";
import { tr } from "date-fns/locale/tr";
import { addFacebookIntegration } from '../../../app/modules/auth/core/_requests'
import axios from 'axios'

type Props = {
  functionSubmit?: any
}
const animatedComponents = makeAnimated();

export class RecollectDatasDto {
  channelId = "";
  dataRetrievalStartDate = new Date();
}

const RecollectDatasModal: FC<Props> = ({ functionSubmit }) => {

  const lang = getConfig()
  const { mode } = useThemeMode()

  useEffect(() => {

    formik.setFieldValue('dataRetrievalStartDate', null)
    if (lang.selectedLang == "tr") {
      registerLocale("tr-TR", tr);
    }
  }, []);

  const createChannelSchema = Yup.object().shape({})
  
  const recollectDatas = async (channelId: string, dataRetrievalStartDate: any,) => {
    const toastId = toast.loading(LanguageHelp('Your process has been started!'));

    var payload = {
      channelId: channelId,
      dataRetrievalStartDate: dataRetrievalStartDate
    };

    return axios.post(`${process.env.REACT_APP_API_URL}/Dashboard/RecollectDatas`, payload)
      .then((response) => {
        if (response.data.httpStatusCode === 200) {
          if (response.data.message !== null) {
            toast.update(toastId, { render: LanguageHelp(response.data.message), type: "warning", isLoading: false, autoClose: 3000 });
          } else {
            toast.update(toastId, { render: LanguageHelp('Data collection has begun!'), type: "success", isLoading: false, autoClose: 3000 });
          }
        } else {
          toast.update(toastId, { render: response.data.message, type: "error", isLoading: false, autoClose: 3000 });
        }
        return response.data.result;
      })
      .then((response: any) => response != null)
  }

  const formik = useFormik({
    initialValues: new RecollectDatasDto(),
    validationSchema: createChannelSchema,
    onSubmit: async (values, { setSubmitting }) => {
      isSuccess = false
      try {
        var isSuccess = await recollectDatas(
          "All Chanels", // values.channelId,
          values.dataRetrievalStartDate,
        )
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
        }
      }
      // }
    },
  })

  React.useEffect(() => {
    formik.validateForm();
  }, [formik.values]);

  return (
    <div className='modal fade' id='kt_modal_recollect_datas' aria-hidden='true'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Recollect Datas')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >

                <div className='card-body border-top'>
                  <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className='svg-icon-2tx svg-icon-warning me-4'
                    />

                    <div className='d-flex flex-stack flex-grow-1'>
                      <div className='fw-bold'>
                        <div className='fs-6 text-gray-600'>
                          {LanguageHelp('The data allowance in your plan will be used to collect the data. Do you want to continue?')}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Data Retrieval Start Date')}</label>
                  <div className='col-lg-8 fv-row'>
                    <div
                      className='btn btn-icon btn-active-color-primary w-40px h-40px me-3' style={{ backgroundColor: mode === 'light' ? "#f5f8fa" : "#1b1b29", marginBottom: "4px" }}
                      onClick={(date) => formik.setFieldValue('dataRetrievalStartDate', null)}
                    >
                      <KTSVG path='/media/icons/duotune/abstract/abs012.svg' className=' svg-icon-1' style={{ filter: mode === 'light' ? "brightness(100%)" : "brightness(200%)", marginBottom: "4px" }} />
                    </div>
                    <DatePicker
                      // showIcon
                      locale={lang.selectedLang == "tr" ? "tr-TR" : "en-US"}
                      className='form-select form-select-solid form-select-lg'
                      dateFormat={lang.selectedLang == "tr" ? "dd.MM.yyyy" : "MM.dd.yyyy"}
                      selected={formik.values.dataRetrievalStartDate}
                      // preventOpenOnFocus={true}
                      // maxDate={new Date()}
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={50}
                      // isClearable 
                      placeholderText={LanguageHelp('Select a date...')}
                      onChange={(date) => formik.setFieldValue('dataRetrievalStartDate', date)}
                    />
                  </div>
                </div>

              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <i className="fas fa-paper-plane"></i>
                  <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { RecollectDatasModal }
